import { EntityNotFoundEndpointError } from '@/authentication/services/errors';

export function throwNotFoundError(): never {
    throw new EntityNotFoundEndpointError();
}
